import { GET_EMPLOYEE_APPLICATION_DETAILS } from "../../enums/Employees/employees.types";

export const getApplicationDetailsAction = (details) => {
    return {
        type: GET_EMPLOYEE_APPLICATION_DETAILS,
        payload: details,
    };
};